import track from './eventTracker';
import SourceType from '../helpers/SourceType';

const determineEventName = source => {
  return source === SourceType.SYL
    ? 'cml.item'
    : 'kept_item_gallery.interaction';
};

const CategoriesCarouselEventTracker = {
  trackCarouselSeenInViewport: ({ categories, source }) => {
    return track({
      action_name: 'category_carousel_view',
      action_type: 'view',
      canonical_name: 'pdp',
      event_name: determineEventName(source),
      source,
      categories: categories.map(category => {
        return {
          id: category.id,
          category_name: category.name,
        };
      }),
    });
  },

  trackCarouselScroll: ({ categoryId, source }) => {
    return track({
      action_name: 'scroll_category_carousel',
      action_type: 'scroll',
      canonical_name: 'pdp',
      event_name: determineEventName(source),
      source,
      category_id: categoryId,
    });
  },

  trackCategoryClick: ({ categoryId, source }) => {
    track({
      action_name: 'click_category_carousel_card',
      action_type: 'click',
      canonical_name: 'pdp',
      event_name: determineEventName(source),
      source,
      category_id: categoryId,
    });
  },

  trackSeeMoreCategoriesClick: ({ categoryId, source }) => {
    track({
      action_name: 'category_carousel_view_see_more',
      action_type: 'click',
      canonical_name: 'pdp',
      event_name: determineEventName(source),
      source,
      collection: categoryId,
    });
  },

  trackCategoryEndCardClick: ({ categoryId, source }) => {
    track({
      action_name: 'category_carousel_end_card',
      action_type: 'click',
      canonical_name: 'pdp',
      event_name: determineEventName(source),
      source,
      collection: categoryId,
    });
  },

  trackCategoryEndCardView: ({ categoryId, source }) => {
    track({
      action_name: 'category_carousel_end_card',
      action_type: 'view',
      canonical_name: 'pdp',
      event_name: determineEventName(source),
      source,
      category_id: categoryId,
    });
  },
};

export default CategoriesCarouselEventTracker;
